import { Box, Button, Typography } from "@mui/material";
import img_success from "../../../assets/images/img_success.webp";

export default function ApplySuccess() {
  return (
    <Box
      sx={{
        minHeight: 400,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={img_success} />
      <Typography fontSize={24} fontWeight={600} color="#1C9BDB" mt={2}>
        Ứng tuyển việc làm thành công
      </Typography>
      <Button
        href="/recruitment"
        variant="contained"
        sx={{
          bgcolor: "#1C9BDB",
          borderRadius: 3.5,
          mt: 2,
          textTransform: "none",
          height: 48,
          px: {
            xs: 0,
            sm: 6,
          },
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Xem danh sách việc làm hiện đang tuyển dụng khác
      </Button>
    </Box>
  );
}
